export default __webpack_public_path__ + "locales/sl/HotkeysPanel.json?hash=e719b1661c91a2eae725ca7c0bdfd81b";